module.exports = global["$"] = require("-!/app/node_modules/source-map-loader/dist/cjs.js!./jquery.js");